import React from 'react';
import PropTypes from 'prop-types';

/**
 * Sold lots + percentage
 *
 * @param {{}} props
 * @constructor
 */
const StatisticsSalesSoldCell = (props) => {
    const sold = props.rowData[props.customCell.options.columnSold];
    const percentage = props.rowData[props.customCell.options.columnPercentage];

    return <span>{`${sold} (${percentage}%)`}</span>;
};

StatisticsSalesSoldCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default StatisticsSalesSoldCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsSalesSoldCell.js